import { useEffect, useRef, useState } from "react";
import { routePath } from "../../app/routes/routepath";
import {
  GetOtpOnEmail,
  UpdatePassword,
  VerifyOtp,
} from "../../api/authApi/loginReq";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import logoImg from "../../assets/logos/white-logo.svg";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDisplay,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import OTPInput from "react-otp-input";
import checkPasswordStrength from "./PasswordValidator";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import ConfirmModal from "../../app/components/WarningModel/ConfirmModel";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [Email, setEmail] = useState("");
  const [EmailWarning, setEmailWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const inputRef = useRef([]);
  const [showPasswordStatus, setShowPasswordStatus] = useState(false);
  const Models = {
    LoginModel: 0,
    ForgotModel: 1,
    EnterOTPModel: 2,
    ResetpasswordModel: 3,
  };
  const [updatePassword, setupdatePassword] = useState({
    password: null,
    confirm_password: null,
  });
  const [emaildisabled, setemaildisable] = useState(false);
  const emailRejex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
  const otpRejex = /^\d{6}$/;
  const [otp, setOtp] = useState("");
  const [showModel, setshowModel] = useState(Models.ForgotModel);
  const [passwordStatus, setPasswordStatus] = useState({
    msg: null,
    result: null,
    color: null,
  });
  const [StatusConfirmPassword, setStatusConfirmPassword] = useState({
    msg: null,
    result: null,
    color: null,
  });
  const [showWarningModal, setshowWarningModal] = useState(false);

  const [timeLeft, setTimeLeft] = useState(0);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const timerRef = useRef(null);

  const Timer_In_Seconds = 300; // 5 minutes

  useEffect(() => {
    const expiryAt = sessionStorage.getItem("otpExpiryAt");

    if (!expiryAt) return;

    const remainingSeconds = Math.floor((Number(expiryAt) - Date.now()) / 1000);

    if (remainingSeconds > 0) {
      setTimeLeft(remainingSeconds);
      setIsOtpExpired(false);
    } else {
      setTimeLeft(0);
      setIsOtpExpired(true);
    }
  }, [Models.ResetpasswordModel === sessionStorage.getItem("showModel")]);

  useEffect(() => {
    if (showModel === Models.ResetpasswordModel && timeLeft <= 0) {
      toast.warning("Session expired. Please request OTP again.");
      sessionStorage.removeItem("otpExpiryAt");
      gotoForgotPassword();
      return;
    }

    if (timeLeft <= 0) {
      clearInterval(timerRef.current);
      if (showModel === Models.EnterOTPModel) {
        setIsOtpExpired(true);
      }
      return;
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [timeLeft, showModel]);

  // use here for set value on any modle if user randomly refresh page.

  useEffect(() => {
    const savedModel = sessionStorage.getItem("showModel");
    if (savedModel !== null) {
      setshowModel(Number(savedModel)); // convert back to number if Models are numeric
      {
        emailRejex.test(sessionStorage.getItem("email")) &&
          setEmail(sessionStorage.getItem("email"));
      }
      // if (savedModel == Models.ResetpasswordModel) {
      //   let expirySeconds = Timer_In_Seconds;
      //   const expiryAt = Date.now() + expirySeconds * 1000;
      //   // store in sessionStorage
      //   sessionStorage.setItem("otpExpiryAt", expiryAt.toString());
      //   setTimeLeft(expirySeconds);
      //   setIsOtpExpired(false);
      // }
    } else {
      gotoForgotPassword();
    }
  }, [showModel]); // empty dependency → runs only once on mount

  const gotoForgotPassword = () => {
    setshowModel(Models.ForgotModel);
    sessionStorage.setItem("showModel", Models.ForgotModel);
    setEmail("");
    sessionStorage.removeItem("email");
    localStorage.removeItem("token");
  };

  const handletoast = () => {
    console.log("clicked contact to support");
    const email_link =
      "https://mail.google.com/mail/?view=cm&fs=1&to=support@techfeatures.com";
    window.open(email_link, "_blank");
  };


  if (isLoading === true) {
    return <LoadingSpinner />;
  }

  const togglePassword = () => {
    if (!showPassword) {
      setshowPassword(true);
    } else if (showPassword) {
      setshowPassword(false);
    }
  };
  const toggleConfirmePassword = () => {
    if (!showConfirmPassword) {
      setshowConfirmPassword(true);
    } else if (showConfirmPassword) {
      setshowConfirmPassword(false);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {
      inputRef.current[index + 1]?.focus();
    }
  };

  const GetOTP = async (e) => {
    e.preventDefault();
    if (!Email) {
      toast.warn("Please fill the email field");
      setIsLoading(false);
      return;
    } else if (!emailRejex.test(Email)) {
      setEmailWarning(true);
      setIsLoading(false);
      return;
    }
    setOtp("");
    setIsLoading(true);
    const payload = {
      email: Email,
    };
    try {
      const res = await GetOtpOnEmail(payload);
      console.log(res);

      if (res.data.result === 1) {
        setIsLoading(false);
        toast.success(res.data.result_value.message);
        setshowModel(Models.EnterOTPModel);
        sessionStorage.setItem("showModel", Models.EnterOTPModel);
        sessionStorage.setItem("email", Email);

        // ✅ START OTP TIMER
        let expirySeconds = res.data.result_value.expiryTimeInSecond;
        const expiryAt = Date.now() + expirySeconds * 1000;
        // store in sessionStorage
        sessionStorage.setItem("otpExpiryAt", expiryAt.toString());

        setTimeLeft(expirySeconds);
        setIsOtpExpired(false);
        return;
      }
      // else if (res.data.result === -1) {
      //   setIsLoading(false);
      //   toast.error(res.data.result_value.message);
      // }
      else if (res.data.result === 3) {
        setIsLoading(false);
        // toast.error(
        //   "Account restricted, please contact Support Team at support@techfeature.in."
        // );
        toast.error(
          <div
            onClick={(e) => {
              e.stopPropagation();
              handletoast(e);
            }}
            style={{ cursor: "pointer" }}
          >
            {res.data.result_value.message}
          </div>,
          {
            closeOnClick: false,
            progressStyle: {
              background: "#ff0000", // change this to the exact color you want
            },
          }
        );
        return;
      } else if (res.data.result === -2) {
        setIsLoading(false);
        toast.warn(res.data.result_value.message);
        return;
      } else if (res.data.result === 0) {
        setIsLoading(false);
        toast.error(
          res.data.result_value.message || res.data.error_value.errorText
        );
        return;
      }
    } catch (err) {
      setIsLoading(false);
      toast.error("Could not send OTP. Please try again");
    }
  };

  const VerifyOTP = async (e) => {
    e.preventDefault();
    if (!otpRejex.test(otp)) {
      toast.warning("Please fill the valid data");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const payload = {
      email: Email,
      otp: otp,
    };
    const res = await VerifyOtp(payload);
    if (res.data.result === 1) {
      setIsLoading(false);
      toast.success(res.data.message);
      setshowModel(Models.ResetpasswordModel);
      localStorage.setItem("token", res.data.result_value);
      sessionStorage.setItem("showModel", Models.ResetpasswordModel);
      setupdatePassword({ password: null, confirm_password: null });

      let expirySeconds = Timer_In_Seconds;
      const expiryAt = Date.now() + expirySeconds * 1000;
      // store in sessionStorage
      sessionStorage.setItem("otpExpiryAt", expiryAt.toString());
      setTimeLeft(expirySeconds);
      setIsOtpExpired(false);
      return;
    } else if (res.data.result === -1) {
      setIsLoading(false);
      toast.warning(res.data.message);
      return;
    } else if (res.data.result === -2) {
      setIsLoading(false);
      toast.warning(res.data.message);
      return;
    } else if (res.data.result === 0) {
      setIsLoading(false);
      toast.error(res.data.error_value.errorText);
      return;
    }
  };

  const updateNewPassword = async (e) => {

    e.preventDefault();
    setIsLoading(true);
    if (updatePassword.confirm_password !== updatePassword.password) {
      toast.warning("Password did not match");
      setIsLoading(false);
      return;
    }
    if (passwordStatus?.result === false) {
      toast.error("Password is weak. Please follow the guidelines.");
      setIsLoading(false);
      return;
    }
    const payload = {
      email: Email,
      newpassword: updatePassword.confirm_password,
    };
    try {
      const response = await UpdatePassword(payload);
      if (response.data.result === 1) {
        setIsLoading(false);
        toast.success(response.data.result_value);
        setupdatePassword({
          email: "",
          password: "",
          confirm_password: "",
        });
        setOtp("");
        setEmail("");
        navigate(`${routePath.login}`);
        return;
      } else if (response.data.result === 2 ||response.data.result=== -2) {
        setIsLoading(false);
        toast.error(response.data.result_value);
        gotoForgotPassword();
        return;
      } else if (response.data.result === 0) {
        setIsLoading(false);
        toast.error(response.data.error_value.errorText);
        return;
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }

    setPasswordStatus({
      msg: null,
      result: null,
      color: null,
    });
  };

  const handleChangeUqdatepassword = (e) => {
    setShowPasswordStatus(true);
    const { name, value } = e.target;

    // Update state correctly
    setupdatePassword((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Check strength only for the password field
    if (name === "password") {
      const passwordStrength = checkPasswordStrength("", value);
      setPasswordStatus(passwordStrength);
    } else if (name === "confirm_password") {
      const passwordStrength = checkPasswordStrength("", value);
      setStatusConfirmPassword(passwordStrength);
    }
  };

  const gotoLogin = () => {
    setshowWarningModal(true);
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    setEmailWarning(false);
  };

  const handleModalResponse = async (choice) => {
    setshowWarningModal(false);
    if (choice == "no") {
      return;
    } else if (choice == "yes") {
      navigate(`${routePath.login}`);
      setEmail("");
    }
  };
  return (
    <>

      {/* Forgot password Model Start*/}

      {showModel === Models.ForgotModel && (
        <div className="form_wraper">
          <div className="form-section">
            <img src={logoImg} alt="TechFeatures" className="logo" />
            <h1>Forgot Password</h1>
            <p>Enter your registered email to get an OTP.</p>
            <div className="login_form">
              <div className="login_input_wraper">
                <i className="bi bi-envelope"></i>
                <input
                  type="email"
                  placeholder="demo@gmail.com"
                  required
                  value={Email}
                  disabled={emaildisabled}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      GetOTP(e);
                    }
                  }}
                />
              </div>
              {EmailWarning && (
                <span className="error-text" role="alert">
                  Please enter a valid email address
                </span>
              )}

              <div className="remember_password">
                <span className="text-remember_password">Remember your password? </span> <span className="remember_password_link" onClick={gotoLogin}>Login</span>
              </div>

              <button
                type="button"
                onClick={GetOTP}
                className="primary_btn w-100"
              >
                Send OTP
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Verify OTP Screen start */}

      {showModel === Models.EnterOTPModel && (
        <div className="form_wraper">
          <div className="form-section">
            <img src={logoImg} alt="TechFeatures" className="logo" />
            <h1>Forgot Password</h1>
            <p> Enter your OTP here!</p>
            <div className="login_form_verifyOTP">
              <div className="login_form_verifyOTP_input_wraper">
                <i className="bi bi-envelope"></i>
                <input
                  type="email"
                  placeholder="demo@gmail.com"
                  required
                  value={Email}
                  disabled
                />
              </div>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderInput={(props) => (
                  <input
                    {...props}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && otp.length >= 6) {
                        VerifyOTP(e);
                      }
                    }}
                  />
                )}
                inputStyle={{
                  width: "55px",
                  height: "55px",
                  fontSize: "20px",
                  borderRadius: "3px",
                  border: "1px solid #555",
                  textAlign: "center",
                  color: "white !important",
                  backgroundColor: "black !important",
                  marginRight: "15px",
                }}
              />

              {/* OTP TIMER */}
              {timeLeft > 0 ? (
                <p className="otp-expiry">
                  OTP expires in{" "}
                  <strong className="otp-timer">
                    {Math.floor(timeLeft / 60) > 0 && (
                      <>
                        <span className="time-box">
                          {Math.floor(timeLeft / 60)}
                        </span>{" "}
                        minute{Math.floor(timeLeft / 60) !== 1 && "s"}{" "}
                      </>
                    )}

                    <span className="time-box">
                      {String(timeLeft % 60).padStart(2, "0")}
                    </span>{" "}
                    second{timeLeft % 60 !== 1 && "s"}
                  </strong>
                </p>
              ) : (
                isOtpExpired && (
                  <p className="otp-expiry" onClick={GetOTP}>
                    Resend OTP
                  </p>
                )
              )}

              {/* <div className="actionBtn">
                <span className="Resend_OTP">
                  {isOtpExpired && (
                    <span
                      onClick={(e) => {
                        GetOTP(e);
                      }}
                    >
                      Resend OTP
                    </span>
                  )}
                </span>
              </div> */}
            </div>
            <button
              type="button"
              onClick={VerifyOTP}
              className="primary_btn w-100"
            >
              Verify OTP
            </button>
          </div>
        </div>
      )}

      {/* Set new reset password screen */}

      {showModel === Models.ResetpasswordModel && (
        <div className="form_wraper">
          <div className="form-section">
            <img src={logoImg} alt="TechFeatures" className="logo" />
            <h1>Update Password</h1>
            <p> Enter your new password here!</p>

            {/* Page TIMER */}
            {timeLeft > 0 && (
              <p className="otp-expiry">
                <strong>Note:</strong> Page will expire in <strong className="otp-timer">
                  {Math.floor(timeLeft / 60) > 0 && (
                    <>
                      <span className="time-box">
                        {Math.floor(timeLeft / 60)}
                      </span> minute{Math.floor(timeLeft / 60) !== 1 && "s"}
                    </>
                  )} 
                  <span className="time-box">{timeLeft % 60}</span> second
                  {timeLeft % 60 !== 1 && "s"}
                </strong>
              </p>
            )}

            <div className="login_form">
              <div className="login_input_wraper">
                <i className="bi bi-envelope"></i>
                <input
                  type="email"
                  placeholder="demo@gmail.com"
                  required
                  value={Email}
                  disabled
                />
              </div>
              <div className="login_input_wraper">
                <i className="bi bi-lock"></i>
                <input
                  ref={(e) => {
                    inputRef.current[0] = e;
                  }}
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  required
                  value={updatePassword.password}
                  onChange={handleChangeUqdatepassword}
                  onKeyDown={(e) => handleKeyDown(e, 0)}
                />
                <span
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    top: "23px",
                    right: "9px",
                    color: "white",
                  }}
                  onClick={togglePassword}
                >
                  <FontAwesomeIcon
                    style={{ fontSize: "14px" }}
                    icon={!showPassword ? faEyeSlash : faEye}
                  />
                </span>
              </div>

              {showPasswordStatus && (
                <span
                  style={{
                    color: passwordStatus?.color || "white",
                  }}
                >
                  {passwordStatus?.msg}
                </span>
              )}
              <div className="login_input_wraper">
                <i className="bi bi-lock"></i>
                <input
                  ref={(e) => {
                    inputRef.current[1] = e;
                  }}
                  name="confirm_password"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  required
                  value={updatePassword.confirm_password}
                  onChange={handleChangeUqdatepassword}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      updateNewPassword(event);
                    }
                  }}
                />
                <span
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    top: "23px",
                    right: "9px",
                    color: "white",
                  }}
                  onClick={toggleConfirmePassword}
                >
                  <FontAwesomeIcon
                    style={{ fontSize: "14px" }}
                    icon={!showConfirmPassword ? faEyeSlash : faEye}
                  />
                </span>
              </div>
              {showPasswordStatus && (
                <span
                  style={{
                    color: StatusConfirmPassword?.color || "white",
                  }}
                >
                  {StatusConfirmPassword?.msg}
                </span>
              )}

              <div className="remember_password">
                {/* <span onClick={gotoLogin}>Remember your password? Login</span> */}
              </div>
              <button
                type="button"
                onClick={updateNewPassword}
                className="secondary_btn w-100"
              >
                Update password
              </button>
            </div>
          </div>
        </div>
      )}

      {showWarningModal && (
        <ConfirmModal
          title="Go to Login"
          message="Are you sure you want to leave this page?"
          confirmText="Go to Login"
          cancelText="Stay here"
          onClose={handleModalResponse}
        />
      )}
    </>
  );
};

export default ForgotPassword;
